export default{
    methods: {

        setScreenLeaveFlgOffMixin: function() {
            this.$store.dispatch("common/setScreenLeaveFlg", false);
        },
        setScreenLeaveFlgOnMixin: function() {
            this.$store.dispatch("common/setScreenLeaveFlg", true);
        },
        getScreenLeaveFlgMixin: function() {
            return this.$store.getters["common/getScreenLeaveFlg"];
        },

        clearStoreForLogOutMixin: function() {
            this.setScreenLeaveFlgOnMixin();
            this.clearReqReqStoreMixin();
            this.clearMasterStoreMixin();
            this.clearAuthcUserStoreMixin();
        },
        clearStoreForEditStartOutMixin: function() {
            this.setScreenLeaveFlgOnMixin();
            this.clearReqReqStoreMixin();
            this.clearMasterStoreMixin();
        },
        clearReqReqStoreMixin: function() {
            this.$store.commit("requestRegInfo/resetState");
        },
        clearMasterStoreMixin: function() {
            this.$store.commit("master/resetState");
        },
        clearAuthcUserStoreMixin: function() {
            this.$store.commit("master/resetState");
        },


        searchKbnNameByCdMixin: function(targetList, targetCd) {
            let retVal = "";
            let searchArry = "";
            if (targetCd == "") {
                return retVal;
            }
            if (targetList == null) {
                return retVal;
            }
            searchArry = targetList.find((v) => v.cd === targetCd);
            if (searchArry != null) {
              retVal = searchArry.name;
            }
            return retVal;
        },
        searchKbnNameByValue1Mixin: function(targetList, value1) {
            let retVal = "";
            let searchArry = "";
            if (value1 == "") {
                return retVal;
            }
            if (targetList == null) {
                return retVal;
            }
            searchArry = targetList.find((v) => v.value1 === value1);
            if (searchArry != null) {
              retVal = searchArry.name;
            }
            return retVal;
        },
        stopVideoMixin: function(object) {
            const tracks = object.video.srcObject.getTracks();
            tracks.forEach(track => {
              track.stop();
            });
            object.video.srcObject = null;
        },

        setCanvasUrlMixin: function(object) {
            let canvas = object.canvas;
            if (canvas.toBlob) {
                canvas.toBlob(function (blob) {
                  // BlobオブジェクトにアクセスできるURLを生成
                //   object.captureUrl =  window.URL.createObjectURL(blob);
                object.captureUrl =  window.URL.createObjectURL(blob);
                object.captureBlob = blob;
                object.cameraDialog = true;
              }, "image/png");
            } else if (canvas.msToBlob) {
                object.captureUrl = window.URL.createObjectURL(canvas.msToBlob());
                object.cameraDialog = true;
            } else {
                object.captureUrl = canvas.toDataURL('image/png');
                object.cameraDialog = true;
            }
        },
    }
};